<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" />
    </v-row>

    <v-row>
      <v-col cols="12">
        <h1 class="brand-text-heading mb-4">
          {{ $route.meta.group === 'about' ? $t('Page.Group.About').toLocaleUpperCase($i18n.locale) : $t('Page.Group.Policies').toLocaleUpperCase($i18n.locale) }}
        </h1>

        <v-divider class="brand-green-dark" />
      </v-col>
    </v-row>

    <v-row v-if="$vuetify.breakpoint.smAndDown">
      <v-col
        class="px-0"
        cols="12"
      >
        <v-tabs
          background-color="transparent"
          class="rounded"
          color="brand-primary"
          hide-slider
          light
        >
          <v-tab
            v-for="(item, i) in itemsFiltered"
            :key="i"
            :to="{name: item.to}"
            active-class="brand-primary brand-green-dark--text"
            class="v-btn--outlined brand-green--text px-4 mx-2 brand-text-title"
          >
            <v-icon
              v-if="item.icon"
              class="mr-3 brand-primary--text"
              v-text="item.icon"
            />

            {{ item.text }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        class="shrink"
      >
        <v-list
          color="transparent"
          nav
        >
          <v-list-item
            v-for="(item, i) in itemsFiltered"
            :key="i"
            :to="{name: item.to}"
            active-class="brand-primary brand-green-dark--text"
            class="v-btn--outlined brand-green--text px-6"
            color="brand-green"
            style="border: var(--v-brand-green-base) 1px solid;"
          >
            <v-list-item-icon v-if="item.icon">
              <v-icon
                class="brand-green--text"
                v-text="item.icon"
              />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title
                class="brand-text-title"
                v-text="item.text.toLocaleUpperCase($i18n.locale)"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col>
        <router-view
          :page-content="$t(`Page.${$route.name}.Body`)"
          :page-title="$t(`Page.${$route.name}.Title`)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PagesMixin from '@/theme/default/views/pages/Pages.js'

export default {
  name  : 'Pages',
  mixins: [PagesMixin],
  data() {
    return {
      items: [
        ///// ABOUT \\\\\
        {
          text : this.$t('Page.PageAbout.Name'),
          icon : 'mdi-store',
          group: 'about',
          to   : 'PageAbout'
        },
        {
          text : this.$t('Page.PageHowItWorks.Name'),
          icon : 'mdi-shopping',
          group: 'about',
          to   : 'PageHowItWorks'
        },
        {
          text : this.$t('Page.PageFaq.Name'),
          icon : 'mdi-help-box',
          group: 'about',
          to   : 'PageFaq'
        },
        {
          text : this.$t('Page.PageContact.Name'),
          icon : 'mdi-message',
          group: 'about',
          to   : 'PageContact'
        },

        ///// POLICIES \\\\\
        {
          text : this.$t('Page.PoliciesTerms.Name'),
          icon : 'mdi-file-document',
          group: 'policies',
          to   : 'PoliciesTerms'
        },
        {
          text : this.$t('Page.PoliciesPrivacy.Name'),
          icon : 'mdi-file-document',
          group: 'policies',
          to   : 'PoliciesPrivacy'
        },
        {
          text : this.$t('Page.PoliciesDsa.Name'),
          icon : 'mdi-file-document',
          group: 'policies',
          to   : 'PoliciesDsa'
        },
        {
          text : this.$t('Page.PoliciesCookies.Name'),
          icon : 'mdi-cookie',
          group: 'policies',
          to   : 'PoliciesCookies'
        },
        {
          text : this.$t('Page.PoliciesReturns.Name'),
          icon : 'mdi-cash-sync',
          group: 'policies',
          to   : 'PoliciesReturns'
        },
        {
          text : this.$t('Page.PoliciesAllergens.Name'),
          icon : 'mdi-food-off',
          group: 'policies',
          to   : 'PoliciesAllergens'
        }
      ]
    }
  }
}
</script>

<style scoped src="@/theme/default/views/pages/Pages.css"></style>
<style scoped>
.v-list-item--active .v-icon, .v-tab--active .v-icon {
  color: var(--v-brand-green) !important;
}

:deep(.v-slide-group__next), :deep(.v-slide-group__prev) {
  flex: 0 1 32px !important;
  min-width: 32px !important;
}

:deep(.v-slide-group__next--disabled), :deep(.v-slide-group__prev--disabled) {
  flex: 0 1 0 !important;
  min-width: 0 !important;
}
</style>
